// extracted by mini-css-extract-plugin
module.exports = {"main":"style_main__2mCfF","password":"style_password__1SrYj","submit":"style_submit__3NQFM","floatleft":"style_floatleft__3uPEw","floatright":"style_floatright__1livH"};